import { Modal, useModal } from "@/shared/modal";
import { HiddenFields } from "@/shared/html-template-editor/html-template-editor/ui/hidden-fields";
import { useTranslations } from "use-intl";
import { ReactNode } from "react";
import { CopyToOthersLanguagesButton } from "@/shared/html-template-editor/copy-to-others-languages-button";
import { Rule } from "@/shared/form/form";
import { DeferredMount } from "../utils/use-deferred-mount";
import { ErrorsTooltip } from "./errors-tooltip";
import { LocaleTabs } from "./locale-tabs";
import OpenHtmlTemplateEditorButton from "./open-html-template-editor-button";
import { ExternalErrorNote } from "./external-error-note";

export type TemplateEditorProps = {
  propertyTree?: ReactNode;
  name: string | string[];
  htmlRules?: Rule[];
};

export default function HtmlTemplateEditor({
  name,
  propertyTree,
  htmlRules,
}: TemplateEditorProps) {
  const { openModal, close, open } = useModal();
  const t = useTranslations("HtmlTemplateEditor");

  return (
    <div>
      <div className="space-x-2">
        <OpenHtmlTemplateEditorButton onOpen={open} />
        <ExternalErrorNote name={name} />
      </div>

      <HiddenFields name={name} htmlRules={htmlRules} />

      <Modal
        open={openModal}
        title={t("Editor")}
        onCancel={close}
        width={"80vw"}
        classNames={{
          body: "!p-0 rounded-none",
        }}
      >
        <DeferredMount>
          <LocaleTabs
            name={name}
            propertyTree={propertyTree}
            errorTooltip={<ErrorsTooltip name={name} />}
            CopyToOthersLanguages={({ activeLanguage }) => (
              <CopyToOthersLanguagesButton
                name={name}
                activeLanguage={activeLanguage}
              />
            )}
          />
        </DeferredMount>
      </Modal>
    </div>
  );
}
